"use client";

import { useNotifications } from "@tosize/ui";
import { Slot } from "radix-ui";
import type { ReactNode } from "react";

interface Props {
	writeText?: string;
	title: string;
	subtitle?: string;
	children: ReactNode;
}

export function CopyButton({ writeText, title, subtitle, children }: Props) {
	const { notify } = useNotifications();

	if (!writeText) {
		return null;
	}

	return (
		<Slot.Root
			onClick={async () => {
				await window.navigator.clipboard.writeText(writeText);
				notify({ variant: "info", title, subtitle: subtitle ?? writeText });
			}}
		>
			{children}
		</Slot.Root>
	);
}
